import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { CustomerUserDeactivationAdminComponent } from './customer-user-deactivation-admin.component';

const routes: Routes = [
  {
    path: '',
    component: CustomerUserDeactivationAdminComponent,
    data: { title: 'Customer User Deactivation Admin' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerUserDeactivationAdminRoutingModule {}

@NgModule({
  imports: [
    CustomerUserDeactivationAdminRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [CustomerUserDeactivationAdminComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CustomerUserDeactivationAdminModule {}
